import type { FluxErrorEntityErrorCodes } from '../types.js';

export const NotificationErrorCodes = {
  NotificationNotFound: {
    code: 'notification/not-found',
    message: 'Notificação não encontrada.',
    explanation: 'A notificação que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'notification'>;

export const NotificationPreferenceErrorCodes = {
  NotificationPreferenceInvalidBitfield: {
    code: 'notification-preference/invalid-bitfield',
    message: 'A configuração de notificações informada é inválida.',
    explanation: 'O bitfield de preferência de notificação é inválido. As configurações de preferência devem ser representadas corretamente.',
    localizations: {},
  },
  NotificationPreferenceInvalidPreferencesForGlobal: {
    code: 'notification-preference/invalid-preferences-for-global',
    message: 'As preferências de notificação globais são inválidas.',
    explanation: 'As preferências de notificação globais fornecidas são inválidas. Algumas configurações de preferência são específicas para fluxos (pipes).',
    localizations: {},
  },
  NotificationPreferenceInvalidPreferencesForPipes: {
    code: 'notification-preference/invalid-preferences-for-pipes',
    message: 'As preferências de notificação para os fluxos são inválidas',
    explanation: 'As preferências de notificação para os fluxos (pipes) fornecidas são inválidas. Algumas configurações de preferência são específicas para notificações globais.',
    localizations: {},
  },
  NotificationPreferenceMaxStarredPipes: {
    code: 'notification-preference/max-starred-pipes',
    message: 'Você atingiu o número máximo de fluxos favoritos.',
    explanation: 'Você atingiu o número máximo de fluxos (pipes) que podem ser marcados como favoritos.',
    localizations: {},
  },
  NotificationPreferenceNotFound: {
    code: 'notification-preference/not-found',
    message: 'Configuração de notificações não encontrada.',
    explanation: 'A configuração de preferência de notificação que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'notification-preference'>;
